import React, { useContext, useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import { FaQuoteLeft, FaArrowRight, FaArrowLeft } from "react-icons/fa";
import { ThemeContext } from "../../contexts/ThemeContext";
import "./Testimonials.css";
import { getFeedbacks } from "../../services/feedbacksApi";
import boy1 from "../../assets/svg/testimonials/boy1.svg";

function Testimonials() {
  const { theme } = useContext(ThemeContext);
  const [references, setReferences] = useState([]);
  const sliderRef = useRef();
  const settings = {
    dots: true,
    adaptiveHeight: true,
    infinite: true,
    speed: 800,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    margin: 3,
    loop: true,
    autoplaySpeed: 5000,
    draggable: true,
    swipeToSlide: true,
    swipe: true,
  };

  const gotoNext = () => {
    sliderRef.current.slickNext();
  };

  const gotoPrev = () => {
    sliderRef.current.slickPrev();
  };

  useEffect(() => {
    getFeedbacks()
      .then(setReferences)
      .catch((err) => console.error(err));
  }, []);

  const truncate = (text) =>
    text.length > 400 ? text.slice(0, 400) + "..." : text;

  return (
    <>
      {references?.length > 0 && (
        <div
          className="testimonials"
          id="referencias"
          style={{ backgroundColor: theme.primary }}
          data-aos="zoom-in"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          data-aos-offset="300"
          data-aos-delay="00"
        >
          <div className="testimonials--header">
            <h1 style={{ color: theme.secondary }}>Referências</h1>
            <span
              className="testimonials--total"
              style={{ color: theme.secondary, borderColor: theme.secondary }}
            >
              {references.length}{" "}
              {references.length === 1 ? "feedback" : "feedbacks"}
            </span>
            <h2 style={{ color: theme.secondary }}>
              Reuni feedbacks de pessoas que já tive o prazer compartilhar o
              mesmo ambiente profissional.
              <br /> Agradeço cada um que enviou uma mensagem. 🙏{" "}
            </h2>
          </div>
          <div className="testimonials--body">
            <FaQuoteLeft className="quote" style={{ color: theme.secondary }} />
            <div
              className="testimonials--slider"
              style={{ backgroundColor: theme.primary }}
            >
              <Slider {...settings} ref={sliderRef}>
                {references?.map((test) => (
                  <div className="single--testimony" key={test.id}>
                    <div className="testimonials--container">
                      <div
                        className="review--img"
                        style={{
                          backgroundColor: theme.secondary,
                        }}
                      >
                        <img src={test.photo_url ?? boy1} alt={test.name} />
                      </div>
                      <div
                        className="review--content"
                        style={{
                          backgroundColor: theme.secondary,
                          color: theme.tertiary,
                        }}
                      >
                        <p>{truncate(test.message)}</p>
                        <h1>{test.name}</h1>
                        <h4>{test.job_title}</h4>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
              <button
                className="prevBtn"
                onClick={gotoPrev}
                style={{ backgroundColor: theme.secondary }}
              >
                <FaArrowLeft
                  style={{ color: theme.primary }}
                  aria-label="Previous testimonial"
                />
              </button>
              <button
                className="nextBtn"
                onClick={gotoNext}
                style={{ backgroundColor: theme.secondary }}
              >
                <FaArrowRight
                  style={{ color: theme.primary }}
                  aria-label="Next testimonial"
                />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Testimonials;
